import removeAccents from 'remove-accents'
import { EPathSegment } from './paths'
import { ESuggestType, TSuggestElement } from '../types/factFinder'

const buildUrlFromSuggestion = (suggestion: TSuggestElement): string => {
  const searchParams = new URLSearchParams()
  searchParams.set('sgt', suggestion.name)

  switch (suggestion.type) {
    case ESuggestType.PRODUCT: {
      const masterId = suggestion.attributes?.masterId
      if (masterId) {
        // no `query` search parameter needed for product detail pages
        return `${EPathSegment.PRODUCT}/${masterId}`
      }
      return buildSearchUrl(searchParams, suggestion.name)
    }
    case ESuggestType.CATEGORY: {
      const value = suggestion.searchParams?.filters?.[0].values?.[0].value || suggestion.attributes?.categoryPath
      if (value) {
        // no `query` search parameter needed for category catalog pages
        return `${EPathSegment.CATEGORY}/${normalizeUrlPathSegment(value)}?${searchParams.toString()}`
      }
      return buildSearchUrl(searchParams, suggestion.name)
    }
    default: {
      return buildSearchUrl(searchParams, suggestion.name)
    }
  }
}

export const normalizeUrlPathSegment = (path: string): string => {
  return removeAccents(
    path
      .toLowerCase()
      .replace(/\u00df/g, 'ss') // replace all 'ß' with 'ss'
      .replace(/\u00e4/g, 'ae') // replace all 'ä' with 'ae'
      .replace(/\u00f6/g, 'oe') // replace all 'ö' with 'oe'
      .replace(/\u00fc/g, 'ue'), // replace all 'ü' with 'ue'
  )
    .replace(/\s/g, '-') // replace all whitespaces with '-'
    .replace(/[^a-z\d-/]/g, '') // remove all characters that are not letters, digits or hyphens
    .replace(/-{2,}/g, '-') // replace all sequences of two or more hyphens with a single hyphen
}

const buildSearchUrl = (searchParams: URLSearchParams, query: string) => {
  searchParams.set('q', query)
  return `${EPathSegment.SEARCH}?${searchParams.toString()}`
}

export default buildUrlFromSuggestion
